import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from '@teamfoster/sdk/button';
import { IsActiveMatchOptions, RouterModule } from '@angular/router';

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestComponent {
  @Input() button!: Button;
  @Input() showText: boolean = true;
  @Input() noLink: boolean = false; // Use this to conditionally wrap in a <a> or not
  @Input() cssClasses: string = '';
  @Input() target: string = '_blank';
  @Input() routerLinkActive: string = 'is--active';
  @Input() queryParams?: IsActiveMatchOptions;
  @Input() fragment?: string;
  @Input() routerLinkActiveOptions: IsActiveMatchOptions | { exact: boolean } = { exact: false };
}
